import { GetPageComponentItemViewModel } from '@/types/cml-api';
import { sendCtaClickEvent } from '@/features/analytics/datalayer/datalayer';
import { Button } from '@/features/button';
import { IconArrowLeft } from '@/features/icons';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Modal } from '@/features/modal';
import { PaginationBackArrow, PaginationNextArrow } from '@/features/pagination/arrows';
import { PaginationArrowSize } from '@/features/pagination/type';
import { Webengage } from '@/features/webengage';
import SafeHtml from '@/components/safe-html';
import { getCdnUrl } from '@/utils/url';
import TextStoryProductCard from './text-story-product-card';
const backgroundImage = getCdnUrl('/_toad/images/text-story-bg.png');
interface Props {
  data?: GetPageComponentItemViewModel;
  sortKey?: string;
  handleClose: () => void;
  backHandler: () => void;
  nextHandler: () => void;
}
const DetailModal = ({
  data,
  handleClose,
  nextHandler,
  backHandler,
  sortKey
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const textStoryItemName = 'TextStoryPage';
  const handleClick = () => {
    const id = data?.id || '';
    const index = data?.index || 0;
    const name = sortKey?.replace('TextStory', textStoryItemName) ?? '';
    const url = data?.link || (data?.product?.slug ? `/products/${data.product.slug}` : '');
    const image = isMobile ? data?.mobileImageUrl : data?.desktopImageUrl;
    sendCtaClickEvent({
      componentId: id,
      elementType: textStoryItemName,
      elementName: name,
      itemID: id,
      elementIndex: index,
      destinationUrl: url,
      ImageUrl: image
    });
    Webengage.trackCtaAction({
      component_id: id,
      banner_type: textStoryItemName,
      banner_name: name,
      item_id: id,
      banner_index: index,
      url_destination: url,
      image_url: image ?? ''
    });
  };
  const destinationUrl = data?.link ?? '';
  return <Modal isOpen={!!data} handleClose={handleClose} title={data?.title} backgroundImage={backgroundImage} className='z-20 h-full bg-cover bg-center pt-3' bodyClassName='pt-2' headClassName='[&>h3]:text-body-16 [&>h3]:before:content-[""] [&>h3]:before:inline-block [&>h3]:before:w-0.5 [&>h3]:before:min-w-0.5 [&>h3]:before:self-stretch [&>h3]:before:ml-3 [&>h3]:before:bg-primary-main [&>h3]:flex [&>h3]:flex [&>h3]:font-medium [&>h3]:items-center' displayType='withLeftBorder' data-sentry-element="Modal" data-sentry-component="DetailModal" data-sentry-source-file="detail-modal.tsx">
            <span className='z-2 absolute right-0 top-0 h-full w-full bg-surface-scrim-white' />

            <div className='relative z-20 flex h-full flex-col justify-between gap-12'>
                <SafeHtml content={data?.text || ''} className='line-clamp-20 text-body-16 leading-8 text-text-black [&>ol]:list-inside [&>ol]:list-decimal [&>ul]:list-inside [&>ul]:list-disc' data-sentry-element="SafeHtml" data-sentry-source-file="detail-modal.tsx" />

                <div className='flex w-full items-end justify-between gap-5'>
                    <div className='flex gap-2'>
                        <PaginationBackArrow size={PaginationArrowSize.Medium} onClick={backHandler} className='bg-surface-scrim-white' data-sentry-element="PaginationBackArrow" data-sentry-source-file="detail-modal.tsx" />
                        <PaginationNextArrow size={PaginationArrowSize.Medium} onClick={nextHandler} className='bg-surface-scrim-white' data-sentry-element="PaginationNextArrow" data-sentry-source-file="detail-modal.tsx" />
                    </div>

                    {data?.product && <TextStoryProductCard product={data?.product} onClick={handleClick} />}
                    {data?.link && <Button size='large' graphicStyle='text' icon={{
          element: <IconArrowLeft />,
          position: 'left'
        }} className='text-primary-main' onClick={() => {
          handleClick();
          window.open(destinationUrl);
        }}>
                            <span>مطالعه بیشتر در مجله خانومی</span>
                        </Button>}
                </div>
            </div>
        </Modal>;
};
export default DetailModal;